import store from '@/store'
class Validation {
  constructor() {
    this.messages = {
      en: {
        required: 'This field is required.',
        requiredIf: 'This field is required.',
        email: 'Please enter a valid email address.',
        minlength: 'Please enter at least {0} characters.',
        maxlength: 'Please enter no more than {0} characters.',
        url: 'Please enter a valid URL.',
        number: 'Please enter a valid number.',
        digits: 'Please enter only digits.',
        alphaNum: 'Please enter only alpha-numeric characters.',
        equalTo: 'Please enter the same value again.',
        min: 'Please enter a value greater than or equal to {0}.',
        max: 'Please enter a value less than or equal to {0}.',
        filesize: 'The file size should be less than {0}.',
        date: 'Please enter a valid date.',
        arrayMin: 'The array length should be greater than or equal to {0}.',
        arrayMax: 'The array length should be less than or equal to {0}.',
        accept: 'The file extension should be: {0}.'
      },
      vi: {
        required: 'Vui lòng nhập dữ liệu.',
        requiredIf: 'Vui lòng nhập dữ liệu.',
        email: 'Vui lòng nhập một địa chỉ email chính xác.',
        minlength: 'Vui lòng nhập nhiều hơn {0} ký tự.',
        maxlength: 'Vui lòng nhập ít hơn {0} ký tự.',
        url: 'Vui lòng nhập một địa chỉ URL chính xác.',
        number: 'Vui lòng chỉ nhập số.',
        digits: 'Vui lòng chỉ nhập kiểu số.',
        alphaNum: 'Vui lòng chỉ nhập kiểu chữ hoặc số.',
        equalTo: 'Vui lòng nhập lại cùng một giá trị.',
        min: 'Vui lòng nhập giá trị lớn hơn hoặc bằng {0}.',
        max: 'Vui lòng nhập giá trị nhỏ hơn hoặc bằng {0}.',
        filesize: 'The file size should be less than {0}.',
        date: 'Vui lòng nhập một ngày.',
        arrayMin: 'Sô lượng chọn nên nhiều hơn hoặc bằng {0}.',
        arrayMax: 'Sô lượng chọn nên ít hơn hoặc bằng {0}.',
        accept: 'Chỉ hỗ trợ các tâp tin có đuôi mở rộng: {0}.'
      },
      default: 'Something went wrong.'
    }
  }

  locale() {
    return store.getters['app/locale'] || 'en'
  }

  option(value) {
    return value === null || value === '' || value === undefined || (Array.isArray(value) && value.length === 0)
  }

  message(key, params = []) {
    const locale = this.locale()
    let message = (this.messages[locale] && this.messages[locale][key])
      ? this.messages[locale][key]
      : this.messages.en[key] || this.messages.default
    params.forEach(function(value, index) {
      message = message.replace(`{${index}}`, value)
    })
    return message
  }

  humanFileSize(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B'
    }

    const units = si
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
    let u = -1
    const r = 10 ** dp

    do {
      bytes /= thresh
      ++u
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

    return bytes.toFixed(dp) + ' ' + units[u]
  }

  // your rule defined

  required(value, message = undefined) {
    return !this.option(value) || message || this.message('required')
  }

  requiredIf(value, before, message = undefined) {
    if (before() === true) {
      return !!value || message || this.message('requiredIf')
    }
    return true
  }

  email(value, message = undefined) {
    return this.option(value) || /.+@.+\..+/.test(value) || message || this.message('email')
  }

  minlength(value, minlength, message = undefined) {
    return this.option(value) || value.length >= minlength || message || this.message('minlength', [minlength])
  }

  maxlength(value, maxlength, message = undefined) {
    return this.option(value) || value.length <= maxlength || message || this.message('maxlength', [maxlength])
  }

  url(value, message = undefined) {
    return this.option(value) || (
      /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
        value
      ) ||
      message ||
      this.message('url')
    )
  }

  number (value, message = undefined) {
    return this.option(value) || (
      /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value) ||
      message ||
      this.message('number')
    )
  }

  digits(value, message = undefined) {
    return this.option(value) || /^\d+$/.test(value) || message || this.message('digits')
  }

  alphaNum(value, message = undefined) {
    return this.option(value) || /^\w+$/.test(value) || message || this.message('alphaNum')
  }

  equalTo(value, getCompareValue, message = undefined) {
    const compareValue =
      typeof getCompareValue === 'function'
        ? getCompareValue()
        : getCompareValue
    return (
      value === compareValue || message || this.message('equalTo')
    )
  }

  min(value, min, message = undefined) {
    return this.option(value) || parseFloat(value) >= min || message || this.message('min', [min])
  }

  max(value, max, message = undefined) {
    return this.option(value) || parseFloat(value) <= max || message || this.message('max', [max])
  }

  filesize(value, max = 5 * 1024 * 1024, message = undefined) {
    if (this.option(value)) {
      return true
    }
    const arr = Array.isArray(value) ? value : [value]

    const check = (item, max, message) => {
      const size = item?.size || 0
      return size <= max || message || this.message('filesize', [this.humanFileSize(max)])
    }

    for (let i = 0; i < arr.length; i++) {
      const output = check(arr[i], max, message)
      if (output !== true) {
        return output
      }
    }

    return true
  }

  date(value, message = undefined) {
    return this.option(value) || /^\d{4}-\d{2}-\d{2}$/.test(value) || message || this.message('date')
  }

  arrayMin(value, noItems, message = undefined) {
    return this.option(value) || value.length >= noItems || message || this.message('arrayMin', [noItems])
  }

  arrayMax(value, noItems, message = undefined) {
    return this.option(value) || value.length <= noItems || message || this.message('arrayMax', [noItems])
  }

  accept(value, accept = 'document', message = undefined) {
    if (this.option(value)) {
      return true
    }

    if (accept === 'image') {
      accept = ['jpg', 'jpeg', 'png', 'gif']
    } else if (accept === 'document') {
      accept = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'jpg', 'jpeg', 'png', 'gif']
    } else {
      accept = Array.isArray(accept) ? accept : [accept]
    }

    const arrValues = Array.isArray(value) ? value : [value]

    const check = (item, acceptTypes, message) => {
      const ext = (item?.name?.split('.').pop()).toLowerCase() || null

      return acceptTypes.includes(ext) || message || this.message('accept', [acceptTypes.map(i => i.toUpperCase()).join('|')])
    }

    for (let i = 0; i < arrValues.length; i++) {
      const output = check(arrValues[i], accept, message)
      if (output !== true) {
        return output
      }
    }

    return true
  }
}

export default new Validation()
